<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <!-- <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-manifest"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un manifest
        </router-link> -->
                <button
                    class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
                    type="button">
                    Exporter
                    <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                </button>
            </div>
            <div class="d-flex align-items-center">
                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher un manifest" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
                <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Code de l'émetteur

                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Référence Sic
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                               Manifeste Date
                            </th>
                            <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Nombre de BL ou Lignes Cargo
                            </th> -->
                            

                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                                ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(manifest, index) in manifests" :key="index">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ manifest.carrierCode }}
                            </td>

                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ manifest.manifestReference }}
                            </td>

                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format_Date(manifest.manifestDate) }}
                            </td>
                            
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ manifest.documents?.length }}
                            </td> -->


                            <td class="shadow-none lh-1 fw-medium text-black-emphasis pe-0">
                                <button type="button"
                                    class="btn btn-primary btn-sm "
                                    @click.stop="$router.push({ name: 'ViewManifestPage', params: { id: manifest.id } })">
                                      <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                                    Détails
                                </button>
                            </td>


                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import ApiService from "@/services/ApiService";
import { suppression, error, format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { Manifest } from "@/models/Manifest";
// import router from "@/router";
// import { useRouter } from "vue-router";

export default defineComponent({
    name: "ListeManifest",
    components: {
        PaginationComponent
    },
    setup() {

        onMounted(() => {
            getAllManifests();
        });

        const manifests = ref<Array<Manifest>>([]);
        const manifest = ref<Manifest>();

        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);
        // const router=useRouter()

        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                getAllManifests(page_, limit_);
            } catch (error) {
                //
            }
        };

        function rechercher() {
            getAllManifests(page.value, limit.value, searchTerm.value);
        }

        // END PAGINATE



        function getAllManifests(page = 1, limi = 10, searchTerm = '') {
            return ApiService.get(`manifests?page=${page}&limit=${limi}&mot=${searchTerm}&`)
                .then(({ data }) => {
                    console.log("les donnees", data);
                    manifests.value = data.data.data;
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                    return data.data;
                })
                .catch(({ response }) => {
                    console.log("NOS ERREURS", response);
                    // error(response.data.message)
                });
        }

        function moddifier(Editmanifests: Manifest) {
            manifest.value = Editmanifests;
        }

        const deleteManifest = (id: number) => {
            ApiService.delete(`/manifests/${id}`)
                .then(({ data }) => {
                    Swal.fire({
                        text: data.message,
                        toast: true,
                        icon: 'success',
                        title: 'General Title',
                        animation: false,
                        position: 'top-right',
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                        heightAuto: false
                    });
                })
                .catch(({ response }) => {
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: "Réssayer à nouveau!",
                        heightAuto: false,
                        customClass: {
                            confirmButton: "btn fw-semobold btn-light-danger",
                        },
                    });
                });

            for (let i = 0; i < manifests.value.length; i++) {
                if (manifests.value[i].id === id) {
                    manifests.value.splice(i, 1);
                }
            }
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }

        return {
            manifests,
            checkPermission,
            getAllManifests,
            deleteManifest,
            moddifier,
            suppression,
            page,
            totalPages,
            limit,
            totalElements,
            handlePaginate,
            rechercher,
            searchTerm,
            format_Date
        };

    },
});
</script>
